import Path from "../Path";
import PathPlanJumpUpLeft from "../plan/PathPlanJumpUpLeft";
import PathPlanJumpUpRight from "../plan/PathPlanJumpUpRight";
import PathTemplatePattern from "./PathTemplatePattern";


// PATTERN VALUES:
// S start
// P path
// E end
// X closed
// O open
// 8 open or path
// . ignore

export default class PatternJumpUp1Side3 extends PathTemplatePattern {
    constructor() {
        super([
            '888E',     // ignore   o|p     o|p     end
            'S8X.'      // start    o|p     o|p     closed
            //'X...'     //  closed   ignore  ignore  ignore
        ],
        true);  // true to flip left/right
    }

    /**
     * Returns the minimum number of path steps required by this pattern to be applied.
     * @override
     * @returns {number}
     */    
    getMinRequiredPathSteps() {
        return 4;
    }

    /**
     * @override
     * @param {Path} path
     * @param {number} pathIndex The path index.
     * @returns {PathPlan}
     */
    getPathPlan(path, pathIndex) {
        const start = path.tiles[pathIndex];

        const targetCol = start.getTileCol() + 3; // end tile is 3 columns to the right of start
        const targetRow = start.getTileRow() - 1; // end tile is one row higher than the start
        const endIndex = this.findTilePathIndex(path, pathIndex + 4, targetCol, targetRow);  // +4: we know the end is at least 4 steps away in the path.
        if (endIndex < 0) {
            return null;
        }

        const end = path.tiles[endIndex];
        const steps = endIndex - pathIndex;

        return new PathPlanJumpUpRight(start, end, steps);
    }

    /**
     * @override
     * @param {Path} path
     * @param {number} pathIndex The path index.
     * @returns {PathPlan}
     */
    getPathPlanFlipped(path, pathIndex) {
        const start = path.tiles[pathIndex];
        
        const targetCol = start.getTileCol() - 3; // end tile is 3 columns to the left of start
        const targetRow = start.getTileRow() - 1; // end tile is one row higher than the start
        const endIndex = this.findTilePathIndex(path, pathIndex + 4, targetCol, targetRow);  // +4: we know the end is at least 4 steps away in the path.
        if (endIndex < 0) {
            return null;
        }

        const end = path.tiles[endIndex];
        const steps = endIndex - pathIndex;

        return new PathPlanJumpUpLeft(start, end, steps);
    }

    /**
     * @override
     * @returns {string}
     */
    toString() {
        return 'PatternJumpUp1Side3';
    }
}